import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-statistics",
  "use": "icon-statistics-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-statistics\"><path d=\"M992.0512 569.2416h-496.64c-17.7152 0-32.0512-14.336-32.0512-32.0512V32.0512c0-17.7152 14.336-32.0512 32.0512-32.0512C786.8416 0 1024 241.0496 1024 537.2928c0 17.6128-14.336 31.9488-31.9488 31.9488z m-464.5888-64h431.5136C943.4112 269.9264 758.3744 81.2032 527.4624 65.1264v440.1152z\" p-id=\"6455\" fill=\"#ffffff\" /><path d=\"M486.5024 1024C218.2144 1024 0 803.6352 0 532.6848 0 299.9296 163.6352 97.4848 389.12 51.2a31.98976 31.98976 0 1 1 12.9024 62.6688C206.1312 154.0096 64 330.1376 64 532.6848c0 235.6224 189.5424 427.3152 422.5024 427.3152 191.3856 0 359.3216-130.56 408.3712-317.44a32.03072 32.03072 0 0 1 61.952 16.2816C900.3008 873.7792 706.9696 1024 486.5024 1024z\" p-id=\"6456\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/statistics.svg
// module id = 2O5N
// module chunks = 32